// extracted by mini-css-extract-plugin
export default {"blankslateContainer":"blankslate-module__blankslateContainer--XazOU","blankslateContent":"blankslate-module__blankslateContent--bJCgm"};